// ─── Simple-mode launcher route (GHE #476) ───
// /app/inicio — the front door for simple mode. `/app` redirects here when the
// mode is on (routes/app/index.tsx).
//
// NOT gated on `simpleMode`. Reaching it with the mode off renders the same
// tiles for every destination you may see, which is harmless and keeps the
// #476 invariant intact: simple mode changes what the app OFFERS, never what a
// route PERMITS. A gate here would make a shared or bookmarked link dead-end
// for the person who sent it — the exact failure the invariant exists to stop.

import { createFileRoute } from '@tanstack/react-router';
import { SimpleLauncher } from '../../features/layout/SimpleLauncher';

export const Route = createFileRoute('/app/inicio')({
  component: SimpleLauncher,
});
